<template>
<!-- 订单列表模板 -->
    <div class="myOrder">
      <!-- 标题 -->
        <div class="title acea-row row-between-wrapper">
          <div>{{OrderInfo.title}}</div>
          <!-- 折叠各种订单 -->
          <!-- <div class="allOrder" @click="openOrClose">
            <span v-if="!this.switch">﹀</span>
            <span v-if="this.switch">︿</span>
          </div> -->
          <!-- <router-link :to="OrderInfo.goToUrl" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link> -->
        </div>
      <!-- list -->
      <div class="orderState acea-row row-middle stateAnimation" >
        <router-link 
            v-for="(item,key) in OrderInfo.list" 
            :key="key"
            :to="item.goToUrl" class="item">
            <div class="pictrue">
              <img :src='item.img' />
              <span
                class="order-status-num"
                v-if="item.number > 0"
                >{{ item.number }}</span
              >
            </div>
            <div>{{item.title}}</div>
        </router-link>
      </div>
    </div>
</template>

<script>
export default {
    name:"UserOrder",
    data () {
      return {
        switch: false
      }
    },
    props:{
        OrderInfo:{
            type:Object,
            default:function(){
                return {
                    title:"",
                    goToUrl:"",
                    list:[
                        {
                            goToUrl:{},
                            img:"",
                            number:0,
                            title:""
                        }
                    ]
                }
            }
        }
    },
    methods: {
      // 控制各类订单打开关闭
      // openOrClose: function () {
      //   this.switch = !this.switch;
      // }
    }
}
</script>

<style scoped>
@keyframes stateHeight {
  0% {
    transform: translateY(-0.3rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}
.pictrue {
  position: relative;
}
.stateAnimation {
  animation-name: stateHeight;
  animation-duration: 0.5s;
}
</style>